const MAX_ITERATIONS = 1000
// typescript?
export class SseClient {
  handlers = {}

  on(event, handler) {
    this.handlers[event] = handler
    return this // fluent API for chaining
  }

  async post(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })

    const contentType = response.headers.get('content-type') || ''
    const isEventStream = contentType.includes('text/event-stream')

    // The request can fail before the stream ever starts (auth / validation
    // middleware, etc.). Those come back as a normal JSON response rather than
    // an event stream, so hand the raw response to the caller's optional
    // 'response-error' handler, which can surface it as a typed error just like
    // any other request. If no handler throws, fall back to a generic error.
    if (!response.ok || !response.body || !isEventStream) {
      const handler = this.handlers['response-error']
      if (handler) {
        await handler(response)
      }
      throw new Error(`Stream failed to start: ${response.statusText}`)
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let buffer = ''

    let i = 0
    while (i < MAX_ITERATIONS) {
      const { done, value } = await reader.read()
      if (done) break

      buffer += decoder.decode(value, { stream: true })
      const parts = buffer.split('\n\n')
      buffer = parts.pop() ?? ''

      for (const part of parts) {
        const event = part.match(/^event: (.+)$/m)?.[1]
        const dataStr = part.match(/^data: (.+)$/m)?.[1]
        if (!event || !dataStr) continue

        const handler = this.handlers[event]
        // console.log('client event', event, dataStr)
        if (handler) handler(JSON.parse(dataStr))
      }
      i++
    }

    if (i >= MAX_ITERATIONS) {
      const handler = this.handlers['error']
      if (handler) {
        handler({
          message: 'Too many iterations in streamed events'
        })
      } else {
        throw new Error('Too many iterations in streamed events')
      }
    }
  }
}
